import { MantineThemeOverride } from '@mantine/core';

export type FileInputTheme = NonNullable<MantineThemeOverride['components']>['FileInput'];

export const FileInput: FileInputTheme = {
  // todo: define
};
